import React from 'react';

const Blog = () => {
    const styles = {textAlign: 'center'};
    return (
        <div>
            <h2 style={styles}>This is Blog</h2>
        </div>
    );
};

export default Blog;